
import { FlattenedItem } from '@/app/features/reports/utils/entities';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '@/components/ui/command';
import { useEffect, useMemo, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

function useListHeaderMenu({ flattenedItems, scrollToHeader }: { flattenedItems: FlattenedItem[], scrollToHeader: (id: string) => void }) {
    const [menu, setMenu] = useState({ open: false, x: 0, y: 0, header: null });
    const menuRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        function handleClickOutside(e) {
            if (menu.open && menuRef.current && !menuRef.current.contains(e.target)) {
                setMenu(m => ({ ...m, open: false }));
                e.stopPropagation();
                e.preventDefault();
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [menu.open]);

    const filteredCommands = useMemo(() => {
        if (menu.open) {
            console.debug('menu', menu.open, menu.header);
            //split header.id into an array and return the first level parts
            const idParts = menu.header.id.split('.');
            const firstLevelParts = idParts.slice(0, menu.header.level + 1).join('.');

            console.debug('firstLevelParts', firstLevelParts, menu.header.level);
            // get all other headers from flattenedItems that have the same firstLevelParts and are the same level.
            const otherHeaders = flattenedItems.filter(item => item.id.startsWith(firstLevelParts));
            console.debug('otherHeaders', otherHeaders);
            return otherHeaders.map(item => ({ id: item.id, label: item.parents?.slice(menu.header.level).join(' > ') || item.title }));
        }
        return [];
    }, [menu.open, menu.header, flattenedItems]);

    // Menu overlay (only one instance, rendered with portal)
    const DropdownMenu = menu.open && createPortal(
        <div
            ref={menuRef}
            style={{
                position: 'fixed',
                top: menu.y,
                left: menu.x,
                background: '#fff',
                boxShadow: '0 4px 16px #0001',
                borderRadius: 6,
                zIndex: 9999,
                minWidth: 180
            }}
        >
            <Command>
                <CommandInput placeholder="Search..." />
                <CommandList>
                    <CommandEmpty>No results.</CommandEmpty>
                    <CommandGroup heading={`Go To`}>
                        {filteredCommands.map(cmd => (
                            <CommandItem
                                key={cmd.id}
                                onSelect={() => {
                                    console.log(`"${cmd.label}" for`, menu.header);
                                    scrollToHeader(cmd.id);
                                    setMenu(m => ({ ...m, open: false }));
                                }}
                            >
                                {cmd.label}
                            </CommandItem>
                        ))}
                    </CommandGroup>
                </CommandList>
            </Command>
        </div>, document.body
    );

    return { DropdownMenu, setMenu };

}

export { useListHeaderMenu };